const PHONE = "0604026840";
const PHONE_DISPLAY = "06 04 02 68 40";
const WHATSAPP_URL = `https://wa.me/33604026840?text=Bonjour%2C%20j%27ai%20besoin%20d%27un%20serrurier%20en%20urgence`;

const stats = [
  { value: "500+", label: "Interventions réussies" },
  { value: "20min", label: "Temps d'intervention moyen" },
  { value: "98%", label: "Clients satisfaits" },
  { value: "24/7", label: "Disponibilité garantie" },
];

export default function AboutSection() {
  return (
    <section id="apropos" className="py-20 md:py-28 bg-[#FFF9E6] relative overflow-hidden">
      {/* Decorative stripe */}
      <div
        className="absolute top-0 left-0 right-0 h-2"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg, #FFB100 0px, #FFB100 20px, #000000 20px, #000000 40px)",
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20locksmith%20technician%20in%20uniform%20installing%20smart%20lock%20on%20apartment%20door%20in%20France%2C%20confident%20expert%20pose%2C%20modern%20tools%2C%20clean%20bright%20hallway%2C%20professional%20photography%2C%20warm%20natural%20lighting%2C%20high%20quality%20realistic%20photo%2C%20French%20residential%20building%20interior&width=800&height=600&seq=about001&orientation=landscape"
                alt="Securycles - Serrurier professionnel Créteil"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-4 -right-4 bg-[#FFB100] text-black rounded-2xl p-4 shadow-lg">
              <p className="font-black text-3xl leading-none">4.9</p>
              <div className="flex gap-0.5 my-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-black text-xs"></i>
                ))}
              </div>
              <p className="text-xs font-bold">Google</p>
            </div>
            {/* Stripe decoration */}
            <div
              className="absolute -top-3 -left-3 w-16 h-16 rounded-xl opacity-80"
              style={{
                backgroundImage:
                  "repeating-linear-gradient(45deg, #FFB100 0px, #FFB100 4px, #000000 4px, #000000 12px)",
              }}
            ></div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#FFB100]/20 text-black text-xs font-black px-3 py-1.5 rounded-full mb-6 uppercase tracking-widest">
              <i className="ri-information-line"></i>
              À propos de Securycles
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-black uppercase leading-tight mb-6">
              Votre Serrurier de
              <br />
              <span className="text-[#FFB100]">Confiance à Créteil</span>
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              <strong>Securycles</strong> est votre serrurier de confiance à Créteil et dans tout le Val-de-Marne. Spécialisés dans l&apos;urgence 24h/24 et 7j/7, nous intervenons rapidement pour toute ouverture de porte, installation de serrure connectée, ou dépannage automobile.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              Notre expertise et notre réactivité font notre réputation. Devis transparent par téléphone, pas de mauvaise surprise à l&apos;arrivée. Nous couvrons l&apos;ensemble des communes du 94 avec un temps d&apos;intervention moyen de 20 minutes.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-white rounded-xl p-4 border border-gray-100">
                  <p className="font-black text-2xl text-black leading-none mb-1">{stat.value}</p>
                  <p className="text-gray-500 text-xs">{stat.label}</p>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={`tel:${PHONE}`}
                className="flex items-center justify-center gap-2 bg-black text-white font-bold text-sm px-6 py-3 rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                {PHONE_DISPLAY}
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#FFB100] text-black font-bold text-sm px-6 py-3 rounded-full hover:bg-yellow-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
